import { observer } from "mobx-react-lite";
import { useCompanyStore } from "../hooks";
import CompanySetupStepOne from "./CompanySetupStepOne";
import CompanySetupStepTwo from "./CompanySetupStepTwo";
import CompanySetupStepThree from "./CompanySetupStepThree";
import CompanySetupStepFour from "./CompanySetupStepFour";
import CompanySetupSummary from "./CompanySetupSummary";

const CompanySetupStepContent = observer(
  ({
    showTargetFrequency = false,
    companyNameError,
    companyNameDescription,
    companyNameDescriptionClassName,
  }) => {
    const { step } = useCompanyStore();

    if (step === 1)
      return (
        <CompanySetupStepOne
          showTargetFrequency={showTargetFrequency}
          companyNameError={companyNameError}
          companyNameDescription={companyNameDescription}
          companyNameDescriptionClassName={companyNameDescriptionClassName}
        />
      );
    if (step === 2) return <CompanySetupStepTwo />;
    if (step === 3) return <CompanySetupStepThree />;
    if (step === 4) return <CompanySetupStepFour />;
    if (step === 5)
      return <CompanySetupSummary showTargetFrequency={showTargetFrequency} />;
    return null;
  },
);

export default CompanySetupStepContent;
